import { DatePipe } from '@angular/common';
import { ChangeDetectorRef, Component, OnInit, ViewChild } from '@angular/core';
import { GridComponent } from '@syncfusion/ej2-angular-grids';
import { DataStateChangeEventArgs, SelectionSettingsModel, TextWrapSettingsModel } from '@syncfusion/ej2-grids';
import { IMyDpOptions } from 'mydatepicker';
import { ToastrService } from 'ngx-toastr';
import { Observable, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { DateService } from 'src/app/date.service';
import { GlobalComponent } from 'src/app/global/global.component';
import { ColumnChangeBO } from '../eligibility270/eligibility270.model';
import { WhereCondition } from '../client-parent/client-parent.model';
import { columnWidth } from '../icd10/icd10.model';
import { GetSFTPLogsBo ,FilterLogsBo } from './authorizationlogs.modal';
import { CommonApiService } from 'src/app/commonapiservice';
@Component({
  selector: 'app-authorizationlogs-logs',
  templateUrl: './authorizationlogs.component.html',
  styleUrls: ['./authorizationlogs.component.scss'],
})
export class AuthorizationLogsComponent implements OnInit {
  getClientNames: any = [];
 
  private onDestroy$: Subject<void> = new Subject<void>();
  @ViewChild('gridSFTPLogs') public gridSFTPLogs: GridComponent;
  public GridDataList: Observable<DataStateChangeEventArgs>;
  FilterDates: FilterLogsBo = new FilterLogsBo();
  SFTPData: any = [];
  ListClientFilter: any;
  public selectionOptions: SelectionSettingsModel;
  RequestPayload: any = [];
  id: string = "00000000-0000-0000-0000-000000000000";
  type: string = "";
  conditionlist: WhereCondition[] = [];
  arraycol: any = [];
  ValidationDate: any;
  columnchange: ColumnChangeBO = new ColumnChangeBO();
  public filterSettings: object;
  public formatOptions: Object;
  initialPage: object;
  public wrapSettings: TextWrapSettingsModel;
  ErrorinitialPage: object;
  ColumnsTlogs: columnWidth[];
  public myDatePickerOptions: IMyDpOptions = {
    dateFormat: "mm/dd/yyyy",
    showClearDateBtn: true,
    editableDateField: true,
  };
  public pageSizes: number[] = [10, 15, 20, 50, 100, 250];
  SFTPLogsBO: GetSFTPLogsBo = new GetSFTPLogsBo();
  AuthImportStatus: string = "";
  constructor(public CommonAPI: CommonApiService,private cdr: ChangeDetectorRef, private datepipe: DatePipe, public toasterService: ToastrService, public dateservice: DateService, public global: GlobalComponent, ) {
    this.GridDataList = CommonAPI;
  }

  ngAfterContentChecked() {
    this.cdr.detectChanges();
  }
  ngOnInit(): void {
  
    if (this.global.globalAgencyId == null || this.global.globalAgencyId == '' || this.global.globalAgencyId == undefined || this.global.globalAgencyId == 0 ) {
      return;
  }
    this.selectionOptions = {
      checkboxOnly: true
    }
    this.formatOptions = { type: 'datetime', format: 'MM/dd/yyyy' };
    this.filterSettings = { type: 'Menu' };
    this.ErrorinitialPage = { pageSize: 10 };
    this.wrapSettings = { wrapMode: 'Content' };
    let TLPage = 10;
    this.initialPage = { currentPage: 1, pageSizes: ['10', '15', '20', '50', '100', '250'], pageSize: TLPage };
    this.SFTPLogsBO.pageitem = TLPage;
    this.getSFTPImportedAuthRecipientName();
  }
  public ngOnDestroy(): void {
    this.onDestroy$.next();
  }
  public onActionComplete(args) {
    if (args.requestType == "columnstate") {
      let hidearr = [];
      let showarr = [];
      this.gridSFTPLogs.columns.forEach(element => {
        if (element.visible == false && element.headerText != "Actions" && element.headerText != "") {
          hidearr.push(element.headerText);
        }
        if (element.visible == true && element.headerText != "Actions" && element.headerText != "") {
          showarr.push(element.headerText);
        }
      })
      var count = 0;
      var count1 = 0;
      if (args.columns.length > 0) {
        if (this.arraycol.length > 0) {
          this.arraycol[0].SFTP_Logs.ShowColumns.forEach(old => {
            showarr.forEach(element => {
              if (old == element) {
                count1 = count1 + 1;
              }
            });
          });
          this.arraycol[0].SFTP_Logs.HideColumns.forEach(old => {
            hidearr.forEach(element => {
              if (old == element) {
                count = count + 1;
              }
            });
          });
          if (this.arraycol[0].SFTP_Logs.ShowColumns.length != count1 || this.arraycol[0].SFTP_Logs.HideColumns.length != count) {
            this.arraycol[0].SFTP_Logs.ShowColumns = showarr;
            this.arraycol[0].SFTP_Logs.HideColumns = hidearr;
            
          }
        }
      }
    }
    this.SFTPLogsBO.currentpageno = this.gridSFTPLogs.pagerModule.pagerObj.currentPage;
    this.SFTPLogsBO.pageitem = this.gridSFTPLogs.pagerModule.pagerObj.pageSize;
    this.conditionlist = [];
    if (args.requestType === "filtering" && args.action === "filter") {
      args.columns.forEach(element => {
        this.conditionlist.push(element.properties);
      });
    }
    if (args.name == "actionBegin" && args.requestType == "filterbeforeopen") {
      this.SFTPLogsBO.type = args.columnType
    }


  }
  //................................................... dataStateChange.................................................
  public dataStateChange(state): void {
    this.type = (state.action.requestType).toString();
    if (this.type != "filterchoicerequest") {
      if ((state.sorted || []).length) {
        this.SFTPLogsBO.orderColumn = state.sorted[0].name;
        this.SFTPLogsBO.orderType = state.sorted[0].direction === 'descending' ? 'desc' : 'asc';
      }
    }
    if (this.type == "filtering" && state.action.action != "clearFilter") {
      this.SFTPLogsBO.field = state.action.currentFilterObject.field;
      this.SFTPLogsBO.matchCase = state.action.currentFilterObject.matchCase;
      this.SFTPLogsBO.operator = state.action.currentFilterObject.operator;
      this.SFTPLogsBO.value = state.action.currentFilterObject.value;
      if (this.SFTPLogsBO.type == "number") {
        this.SFTPLogsBO.value = state.action.currentFilterObject.value.toString();
        this.SFTPLogsBO.field = state.action.currentFilterObject.field;
      }
      else if (this.SFTPLogsBO.type == "datetime") {
        this.SFTPLogsBO.value = this.global.getDateTimeString(state.action.currentFilterObject.value);
        this.SFTPLogsBO.field = state.action.currentFilterObject.field;
      }
      else {
        this.SFTPLogsBO.value = state.action.currentFilterObject.value;
        this.SFTPLogsBO.field = state.action.currentFilterObject.field;
      }
      this.SFTPLogsBO.matchCase = state.action.currentFilterObject.matchCase;
      this.SFTPLogsBO.operator = state.action.currentFilterObject.operator;
    }
    else {
      if (this.type == "filtering" && state.action.action == "clearFilter") {
        this.SFTPLogsBO.field = "companyName";
        this.SFTPLogsBO.matchCase = false;
        this.SFTPLogsBO.operator = "startswith";
        this.SFTPLogsBO.value = "";
        this.SFTPLogsBO.type = "string";
      }
    }
    if (this.type != "refresh") {
      this.ApplyFilter();
    }
    if (this.type == "paging" && state.action.name == "actionBegin") {
      if (this.arraycol.length != 0) {
        if (this.arraycol[0].SFTP_Logs.Pagesize != state.take) {
          this.arraycol[0].SFTP_Logs.Pagesize = state.take
        }
      }
      
    }
  }
  //.............................................onResize.................................................................
  onResize(args) {
    if (this.ColumnsTlogs != null && this.ColumnsTlogs != undefined) {
      const column = this.gridSFTPLogs.getColumnByField(args.column.field)
      column.width = args.column.width;
      this.gridSFTPLogs.refreshHeader();
      this.ColumnsTlogs.forEach(element => {
        if (element.column == column.headerText) {
          element.width = parseInt(column.width.toString());
        }
      });
      
    }
  }

  //..................................................getSFTPLogsFilter...........................................
  getSFTPLogsFilter() {
    let responseData =
    {
      result: "result",
      count: "count",
    }
    let url = "api/SFTPAuthFile/GetSFTPImportedAuthDetail"
    this.SFTPLogsBO.authDetailImportStatus = this.AuthImportStatus;
    if(this.SFTPLogsBO.authDetailImportStatus == "")
    this.SFTPLogsBO.authDetailImportStatus = null;
    this.CommonAPI.outputValues(url, this.SFTPLogsBO, responseData, "");
    let count = 0
    this.GridDataList.pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
      this.SFTPData = data.result;
      count = count + 1;
      if (this.global.globalAgencyId != 0) {
        if (data != null && data.result.length > 15) {
          this.gridSFTPLogs.height = '500';
        }
        else {
          this.gridSFTPLogs.height = 'auto';
        }
      }
    })
  }
  //..................................................showorhidecolumns...........................................
  showorhidecolumns() {
    this.gridSFTPLogs.openColumnChooser(200, 50);
  }
  //..................................................newdates...........................................
  newdates(event, type, name) {
    if (type == "inputchanged") {
      if (name == 'FromDate') {
        let val = this.dateservice.inputFeildchange(event);
        if (val != undefined) {
          let val1 = this.dateservice.inputFeildchange(event);
          this.FilterDates.FromDate = val1;
        }
      }
      if (name == 'ToDate') {
        let val = this.dateservice.inputFeildchange(event);
        if (val != undefined) {
          let val1 = this.dateservice.inputFeildchange(event);
          this.FilterDates.ToDate = val1;
        }
      }
    }
    if (type == "datechanged") {
      if (name == 'FromDate') {
        let val = this.dateservice.Datechange(event);
        if (val != undefined) {
          let val1 = this.dateservice.Datechange(event);
          this.FilterDates.FromDate = val1;
          var StartDate = new Date(this.FilterDates.FromDate);
          let setDate = StartDate.setDate(StartDate.getDate() + 30);
          let getDate = setDate;
          this.ValidationDate = this.datepipe.transform(getDate, "MM/dd/yyyy");
          this.clearEndTimeValidation();
        }
      }
      if (name == 'ToDate') {
        let val = this.dateservice.Datechange(event);
        if (val != undefined) {
          let val1 = this.dateservice.Datechange(event);
          this.FilterDates.ToDate = val1;
          this.clearEndTimeValidation();
        }
      }
    }
  }
  clearEndTimeValidation() {
    if (this.FilterDates.FromDate != null && this.FilterDates.FromDate != undefined && this.FilterDates.FromDate != '' &&
      this.FilterDates.ToDate != null && this.FilterDates.ToDate != undefined && this.FilterDates.ToDate != '') {
      let EndDate = this.datepipe.transform(this.FilterDates.ToDate, "MM/dd/yyyy");
      if (new Date(EndDate).getTime() > new Date(this.ValidationDate).getTime()) {
        this.toasterService.error("Date range should not be greater than 30 days");
        setTimeout(() => {
          this.toasterService.clear();
        }, 3000);
        this.FilterDates.ToDate = null;
      }
      if (this.FilterDates.ToDate != null && this.FilterDates.ToDate != undefined && this.FilterDates.ToDate != '') {
        if (new Date(this.FilterDates.FromDate).getTime() > new Date(this.FilterDates.ToDate).getTime()) {
          this.FilterDates.ToDate = null;
          this.toasterService.error("end time should greater than start time");
          setTimeout(() => {
            this.toasterService.clear();
          }, 3000);
          return;
        }
      }
    }
  }
  //..................................................ApplyFilter...........................................
  ApplyFilter() {
    if (this.FilterDates.FromDate == undefined || this.FilterDates.FromDate == "" || this.FilterDates.FromDate == null) {
      this.SFTPLogsBO.startDate = null;
    }
    else {
      this.SFTPLogsBO.startDate = this.global.getDateTimeString(this.FilterDates.FromDate);
    }
    this.SFTPLogsBO.recipientName = this.ListClientFilter;
    if (this.FilterDates.ToDate == undefined || this.FilterDates.ToDate == "" || this.FilterDates.ToDate == null) {
      this.SFTPLogsBO.endDate = null;
    }
    else {
      this.SFTPLogsBO.endDate = this.global.getDateTimeString(this.FilterDates.ToDate);
    }
    this.getSFTPLogsFilter();
  }
  show() {
    this.gridSFTPLogs.openColumnChooser(200, 50);
  }

  getError(Payload) {
    this.RequestPayload = Payload;
  }
  //..................................................getSFTPImportedAuthRecipientName...........................................
  getSFTPImportedAuthRecipientName() {
    let url = "api/SFTPAuthFile/getSFTPImportedAuthRecipientName?";
    this.CommonAPI.GetFunctionwithResponseTypeJson("",url).pipe(takeUntil(this.onDestroy$)).subscribe((res: any) => {
      res.forEach(array => {
        if (array != null) {
          let sftplogsClient = {
            "Value": array
          }
          this.getClientNames.push(sftplogsClient)
        }
      });
    },
      (err: any) => {

      })
  }
}
